(function ($) {
  /**
   * Shopify Account functionality.
   */
  var Account = {
    customerId: theme.customerId,
    $accountSettings: null,
    shopUrl: null,
    getShopUrl: function () {
      switch (theme.shopPermamentDomain) {
        case 'devmodifyhealth.myshopify.com':
          return 'https://devmodifyhealth.myshopify.com/tools/softserve';
        case 'test-modifyhealth.myshopify.com':
          return 'https://test-modifyhealth.myshopify.com/tools/softserve';
        case 'modifyhealth.myshopify.com':
          return 'https://modifyhealth.com/tools/softserve';
        default:
          return 'https://modifyhealth.com/tools/softserve';
      }
    },

    init: function () {
      this.$accountSettings = $('#account-settings');
      this.shopUrl = this.getShopUrl();
      this.initReport();
      this.saveUserAddress();
      this.checkForLoggedUser();
    },
    /**
     * Save user address to ReCharge profile, during Shopify save address
     */
    saveUserAddress: function () {
      var $this = this;
      if (!$('.address__list .address__item--default').length) return false;

      var $form = $('.address__item form'),
        url = cryptUrl($this.shopUrl + '/api/customers/' + $this.customerId + '/addresses/update');

      $form.on('submit', function (e) {
        e.preventDefault();
        var $form = $(this);
        var data = {
          addressOne: $form.find('input[name="address[address1]"]').val(),
          addressTwo: $form.find('input[name="address[address2]"]').val(),
          city: $form.find('input[name="address[city]"]').val(),
          country: $form.find('select[name="address[country]"]').val(),
          company: $form.find('input[name="address[company]"]').val(),
          firstName: $form.find('input[name="address[first_name]"]').val(),
          lastName: $form.find('input[name="address[last_name]"]').val(),
          phone: $form.find('input[name="address[last_name]"]').val(),
          state: $form.find('select[name="address[province]"]').val(),
          zipCode: $form.find('input[name="address[zip]"]').val(),
        };

        var addressLine = $form.find('input[name="address[address1]"]').val();

        if (history.pushState) {
          var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?address_data=' + addressLine;
          window.history.pushState({ path: newurl }, '', newurl);
        }

        $.ajax({
          type: 'POST',
          url: url,
          dataType: 'json',
          data: JSON.stringify(data),
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          success: function () {
            $form.unbind('submit').submit();
          },
          error: function (jqXHR, textStatus, errorThrown) {
            $form.unbind('submit').submit();
            ModifyHealth.Sentry.captureException(errorThrown);
          },
        });
      });
    },
checkForLoggedUser: function () {
  var $this = this;
  if (!this.customerId) return;
  if (!document.getElementById('already-subscriber-modal')) return;
  if (this._subInit) return;
  this._subInit = true;

  var selector = '.list-view-item__group-price a, a.product-card__image-wrapper, a.product-card__title, a.product-card__fw-link, .template-page #MainContent a[href*="/products/"]';
  var status = null;        // null = статус ще невідомий
  var pendingHref = null;

  function openModal(href) {
    $('.bv-meal-url').attr('href', href);
    var modalEl = document.getElementById('already-subscriber-modal');
    try { MicroModal.close('already-subscriber-modal'); } catch (err) {}
    modalEl.classList.remove('is-open');
    modalEl.setAttribute('aria-hidden', 'true');
    setTimeout(function () {
      MicroModal.show('already-subscriber-modal', { awaitCloseAnimation: false, disableScroll: true });
    }, 0);
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest(selector);
    if (!link) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;

    if (status === 'ACTIVE') {
      e.preventDefault();
      e.stopPropagation();
      openModal(link.getAttribute('href'));
    } else if (status === null) {
      e.preventDefault();
      e.stopPropagation();
      pendingHref = link.getAttribute('href');
    }
  }, true);

  $.ajax({
    url: cryptUrl($this.shopUrl + '/api/customers/' + $this.customerId + '/accountSettings'),
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    success: function (data) {
      status = String(data.subscriptionStatus).toUpperCase() === 'ACTIVE' ? 'ACTIVE' : 'OTHER';
      if (pendingHref) {
        if (status === 'ACTIVE') openModal(pendingHref);
        else window.location.href = pendingHref;
        pendingHref = null;
      }
    },
    error: function () {
      status = 'OTHER';
      if (pendingHref) {
        window.location.href = pendingHref;
        pendingHref = null;
      }
    }
  });
},
    /**
     * Show Report markup
     */
    initReport: function () {
      var $this = this;

      if ($this.customerId) {
        if (!$('.report--disabled').length) {
          $.ajax({
            url: cryptUrl($this.shopUrl + '/api/reports/0/customers/' + $this.customerId),
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            success: function (data, _textStatus, xhr) {
              $('[data-customer-required="1"]').toggle(xhr.status === 200);
              $('[data-customer-required="0"]').toggle(xhr.status !== 200);
              if (xhr.status === 200) {
                var iframeSrc = cryptUrl('/tools/softserve/Report/Index/' + $this.customerId);
                $('#reportContainer').append('<iframe src="' + iframeSrc + '" width="100%" height="2000px"></iframe>');
                // $this.checkForLoggedUser(data);
              }
            },
            error: function () {
              $('[data-customer-required="1"]').hide();
              $('[data-customer-required="0"]').show().css({ display: 'block' });
            },
          });
        } else {
          $('[data-customer-required="1"]').hide();
          $('[data-customer-required="0"]').show().css({ display: 'block' });
        }

        if ($this.$accountSettings.length) {
          var url = $this.shopUrl + '/api/customers/' + $this.customerId + '/accountSettings';
          var $included = $('#account-settings-included');
          var $status = $('#account-settings-status');

          $.ajax({
            url: cryptUrl(url),
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            success: function (data) {
              function formMealsMarkup(meal) {
                var diet = meal.name.split('diet_')[1] + ': ';
                var breakfasts = meal.breakfastsCount === 0 ? '' : meal.breakfastsCount + 'X Breakfasts';
                var entrees = meal.entriesCount === 0 ? '' : meal.entriesCount + 'X Entrees';
                if (meal.breakfastsCount > 0 && meal.entriesCount > 0) breakfasts += ', ';
                return diet + breakfasts + entrees + '</br>';
              }
              if (data.preference.exclusions !== null && data.preference.meals !== null) {
                var exclusions = data.preference.exclusions.length ? data.preference.exclusions.replace(/,/gi, ', ') : 'None';
                var meals = data.preference.meals;
                var mealsMarkup = '';

                meals.forEach(function (meal) {
                  mealsMarkup += formMealsMarkup(meal);
                });
                $included.html('<p>' + mealsMarkup + 'Excluded ingredients: ' + exclusions + ' </p>');

                $('.ac-table__item--data').addClass('active');
              }
              $status.html('<p> My plan is ' + data.subscriptionStatus + '</p>');
            },
            error: function (jqXHR) {
              if (jqXHR.status !== 400) {
                $status.html('<p> My plan is INACTIVE</p>');
              }
            },
          });
        }
      }
    },
  };
  $(document).ready(function () {
    Account.init();
  });
})(jQuery);
